import { isNullish } from '@caresend/utils';

const isItemWithComputed = (i) => !isNullish(i === null || i === void 0 ? void 0 : i.computed) && 'computed' in i;
const itemWithComputedToRaw = (_item) => {
    const item = { ..._item };
    item === null || item === void 0 ? true : delete item.computed;
    if (Object.values(item).length === 0)
        return null;
    return item;
};
const isRecordManagerWithWorkflows = (obj) => obj.getters.workflows !== undefined;
/**
 * Set a nested value on a record, handling both object properties and array indices.
 *
 * @param obj - The object to set the value on.
 * @param path - The path to the value to set separated by `/`.
 * @param value - The value to set the nested key to.
 * @returns The updated object.
 */
const setNestedChildOnRecord = (obj, path, value) => {
    var _a;
    const keys = path.split('/');
    const key = keys.shift();
    if (!keys.length) {
        return {
            ...obj,
            [key]: value,
        };
    }
    const currentValue = obj[key];
    const restPath = keys.join('/');
    if (Array.isArray(currentValue)) {
        const index = parseInt((_a = keys[1]) !== null && _a !== void 0 ? _a : '', 10);
        const newArray = [...currentValue];
        if (keys.length === 2) {
            newArray[index] = value;
        }
        else {
            newArray[index] = setNestedChildOnRecord(newArray[index] || {}, keys.slice(1).join('/'), value);
        }
        return {
            ...obj,
            [key]: newArray,
        };
    }
    return {
        ...obj,
        [key]: setNestedChildOnRecord(currentValue || {}, restPath, value),
    };
};

export { isItemWithComputed, isRecordManagerWithWorkflows, itemWithComputedToRaw, setNestedChildOnRecord };
